import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';

//app

import { UserChangepwdComponent } from './user-changepwd.component';

import { UserService } from '../user.service';
import { Md5 } from 'ts-md5';
import { MessageError, AlertType, UserRole, ISave } from 'base-models';
import { EditBaseComponent } from '@solar/shared/edit-base.component';
import { ErrorcontrolService } from 'basecomponents';
import { SystemRoles, User, UserProfile } from 'solar-bo';
import { GlobalService } from '@solar/services/global.service';


@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent extends EditBaseComponent implements OnInit, OnChanges {

  nopwd: string = "**************";
  @Input() model: User; // = { id: '-1', fullname: '' };
  get user(): User {
    //to avoid errors with inherited user field that corresponds to user logged
    return this.model;
  }  

  roles: UserRole[] = [];


  constructor(
    private adminService: UserService
    , private globalService: GlobalService
    , private fb: FormBuilder
  ) {

    super();
    this.createForm();
    this.configRoles();
    
  }



  ngOnInit() {
    this.setForm();
    this.loading = false;
  }

  // only called for/if there is an @input variable set by parent.
  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName === 'model') {
        let parentmodel = changes['model'].currentValue;
        this.model = parentmodel;
        if (this.model.profile == null) {
          this.model.profile = new UserProfile();
        }
        this.setForm();
      } else {
      }
    }
  }

    configRoles() {
    this.roles = [];
    let company = this.globService.currentUserValue.company;
    let roles = company.info.user_profiles;
    if (roles) {
      for (let rol of roles) {
        let r = SystemRoles.roles.find(elem => elem.id == rol);
        if (r) {
          this.roles.push(r);
        }
      }
    }
  }

  createForm() {
    this.myform = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
      name: ['', Validators.required],
      surname: ['', Validators.required],
      position: ['', Validators.required],
      phone: [''],
      profile: [[], Validators.required],
      confirmpassword: ['']
    }
      , {
        validator: this.MustMatch('password', 'confirmpassword')
      }
    );
  }

  setForm() {
    let phone="";
    if (this.model.info.phone){
      //this version only allow 1
      phone=this.model.info.phone[0];
    }
    this.myform.reset({
      name: this.model.name,
      surname: this.model.surname,
      position: this.model.info.position,
      phone: phone,
      username: this.model.username,
      password: this.nopwd,
      confirmpassword: this.nopwd,
      profile: this.model.profile.access_level,
    });
  }

  isvalid() {
    return this.myform.valid && !this.loadinglist;
  }

  refModel: ISave;
  saveModel(refModel?: ISave) {
    if (this.uitype != 2) {
      this.submitted = true;
      this.loadinglist = true;
    }
    if (refModel) {
      this.refModel = refModel;
      refModel.loadinglist = true;
      refModel.submitted = true;
    }

    this.alertmessage = null;

    try {
      const clonemodel: User = this.prepareSave();
      //console.log("Useredit to save" + JSON.stringify(clonemodel));
      //update
      this.adminService.updateUser(clonemodel)
        .subscribe(userSaved => this.handleresult(clonemodel,userSaved), err => this.handleError(err)
        );
    } catch (error) {
      this.alertmessage = ErrorcontrolService.basichandleError("", error);
      this.submitted = false;
      this.loadinglist = false;
      console.log(error);
    }

  }

  handleresult(resultmodel: User,userSaved:User) {
    let msg = new MessageError(AlertType.Success, 'User saved. ');
    if (this.uitype != 2) {
      this.alertService.success("User saved");
      this.alertmessage = msg;
    }
    Object.assign(this.model,userSaved);
    if (this.refModel) {
      this.refModel.loadinglist = false;
      this.refModel.submitted = false;
      if (this.model.id == this.globService.currentUserValue.id) {
        Object.assign(this.globService.currentUserValue,userSaved);
        msg.text += ' <br><i class="fas fa-exclamation-circle"></i> In this version when current user sites are changed youn need to login again to get new selected sites.';
      }
      this.refModel.alertmessage = msg;
    }

    //this update the model passed original

    this.model.id = resultmodel.id;
    this.model.name = resultmodel.name;
    this.model.surname = resultmodel.surname;
    this.model.info.position = resultmodel.info.position;
    this.model.info.phone = resultmodel.info.phone;
    this.model.username = resultmodel.username;
    this.model.password = resultmodel.password;
    this.model.profile = resultmodel.profile;


    this.loadinglist = false;
    this.submitted = false;
    this.saveEvent.next(this.model);
    this.globalService.addAction("USER_CHANGED",this.model);
  }

  handleError<T>(err: any) {
    let msg = ErrorcontrolService.basichandleError("Error saving client. Message: ", err);
    if (this.uitype != 2) {
      this.alertService.error("Error saving client. Message: " + err.message);
      this.alertmessage = msg;
    }
    if (this.refModel) {
      this.refModel.loadinglist = false;
      this.refModel.submitted = false;
      this.refModel.alertmessage = msg;
    }
    this.loadinglist = false;
    this.submitted = false;
  }

  prepareSave(): any {
    const formModel = this.myform.value;
    // return new object containing a combination of original value(s)
    // and deep copies of changed form model values
    const cloneModel: User = new User();

    cloneModel.id = this.model.id;
    cloneModel.id_company = this.globService.currentUserValue.company.id;
    cloneModel.name = formModel.name;
    cloneModel.surname = formModel.surname;

    let access_level = formModel.profile;
    cloneModel.profile = new UserProfile();
    cloneModel.profile.access_level = access_level;

    cloneModel.username = formModel.username;
    let pwd: string = formModel.password;
    if (pwd !== this.nopwd) {
      const hashpsw = Md5.hashStr(formModel.password).toString();
      cloneModel.password = hashpsw;
    }
    else {
      //cloneModel.password = this.nopwd;
    }

    cloneModel.info = this.model.info;
    cloneModel.info.position = formModel.position;
    let phone=formModel.phone;
    cloneModel.info.phone = [formModel.phone];

    return cloneModel;
  }


  changepwd_openmodal() {
    UserEditComponent.openChangePwdModal(this.dialog, this.model);
  }


  public static openChangePwdModal(dialog: MatDialog, model: User): MatDialogRef<any> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "400px";
    dialogConfig.data = { component: UserChangepwdComponent, model: model };

    let dialogRef: MatDialogRef<UserChangepwdComponent>;
    dialogRef = dialog.open(UserChangepwdComponent, dialogConfig);
    return dialogRef;
  }

  // custom validator to check that two fields match
  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      if (control.value === this.nopwd) {
        return true;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }


}


